import { useTranslation } from 'react-i18next';
import { setLanguage } from '../../i18n';
import { useLanguageList } from '../../hooks/useLanguageList';

/**
 * User menu row: "Хэл [Монгол|English]" — switch in one click, without opening Appearance. Each language is shown in
 * its own name, so someone stuck in a language they cannot read still finds theirs.
 */
export function LanguageSwitch() {
  const { t, i18n } = useTranslation();
  const languages = useLanguageList();
  return (
    <div className="px-4 py-1.5 border-b border-line flex items-center justify-between gap-2">
      <span className="text-sm text-muted">{t('appearance.language.title')}</span>
      <div role="group" aria-label={t('appearance.language.title')} className="flex flex-wrap justify-end gap-1">
        {languages.map((l) => {
          const selected = i18n.resolvedLanguage === l.code;
          return (
            <button
              key={l.code}
              type="button"
              lang={l.code}
              aria-pressed={selected}
              onClick={() => void setLanguage(l.code)}
              className={`min-h-11 px-2.5 text-sm rounded-control transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary ${
                selected ? 'bg-tint text-on-tint font-medium' : 'text-ink hover:bg-surface-2'
              }`}
            >
              {l.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
